const styles = {
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
    },
    signIn_Btn: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        borderRadius: '16px',
        fontSize: '16px',
        textTransform: 'none',
        marginTop: '40px',
        backgroundColor: '#3876AA',
        color: '#FFFFFF',
    },
    title: {
        fontFamily: 'Silka_Bold',
        fontWeight: 700,
        fontSize: '28px',
        lineHeight: '42px',
    },
    subTitle: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '18px',
        lineHeight: '27px',
        marginBottom: '48px',
        color: '#3876AA',
    },
    forgot_password: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
    },
    remember_me: {
        fontFamily: 'Silka_Regular',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#5C697B',
    },
    checkbox: {
        color: '#8697AB',
        transform: 'scale(0.9)',
        paddingRight: '12px',
    },
};
export default styles;
